import * as angular from 'angular';
import { convertHoursFormatToMinutes, convertMinutesToHoursFormat } from 'data/date';
import { debouncedCall } from 'data/function';
import { InputValidation, InputValidationRule } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/Input';
import { BuilderFeatures } from '../../BuilderFeatures';
export const CONTENT_TYPES = [
    'text/plain',
    'application/json',
    'application/vnd.lime.media-link+json',
    'application/vnd.lime.web-link+json',
    'application/vnd.lime.select+json',
    'application/vnd.lime.document-select+json',
    'application/vnd.lime.collection+json',
    'application/vnd.lime.location+json',
    'application/vnd.lime.input+json',
    'application/vnd.lime.chatstate+json',
    'application/vnd.lime.list+json',
    'application/vnd.lime.container+json',
    'application/vnd.lime.invoice+json',
    'application/vnd.lime.invoice-status+json',
    'application/vnd.lime.payment-receipt+json',
    'application/vnd.lime.sensitive+json',
    'application/vnd.iris.resource+json',
    'application/vnd.lime.redirect+json',
];
export var CONTENT_INPUT_VALUES;
(function (CONTENT_INPUT_VALUES) {
    CONTENT_INPUT_VALUES["TEXT"] = "text";
    CONTENT_INPUT_VALUES["NUMBER"] = "number";
    CONTENT_INPUT_VALUES["DATE"] = "date";
    CONTENT_INPUT_VALUES["REGEX"] = "regex";
    CONTENT_INPUT_VALUES["TYPE"] = "type";
})(CONTENT_INPUT_VALUES || (CONTENT_INPUT_VALUES = {}));
export class InputController {
    static $inject = ['action', 'state', '$timeout', 'close', '$translate', 'application', 'PipelineBuilderSegmentService', '$onStateChanged', 'UndoRedoService'];
    constructor(action, state, $timeout, close, $translate, application, PipelineBuilderSegmentService, $onStateChanged, UndoRedoService) {
        this.action = action;
        this.state = state;
        this.$timeout = $timeout;
        this.close = close;
        this.$translate = $translate;
        this.application = application;
        this.PipelineBuilderSegmentService = PipelineBuilderSegmentService;
        this.$onStateChanged = $onStateChanged;
        this.UndoRedoService = UndoRedoService;
        this.hasSaveReply = false;
        this.maxLength = 50;
        this.nameOfVariable = '{{NameOfVariable}}';
        this.isValidInput = false;
        this.inputTextPlaceholder = '';
        this.errorMessage = '';
        // OnAction functions
        this.onVariableChange = (event) => {
            if (this.shouldIgnoreEvent(event)) {
                return;
            }
            this.executeWithUndoRedo(this.input.variable, event?.target?.value, (value) => {
                if (value !== undefined && this.inputToVariableEnabled) {
                    this.input.variable = value;
                }
                this.save();
                this.checkInputVariable();
            }, 1000);
        };
        this.onChangeRule = (event = undefined) => {
            if (!this.input.validation || !event || event.detail.value === 'undefined' || this.shouldIgnoreEvent(event)) {
                return;
            }
            this.executeWithUndoRedo(this.input.validation?.rule, event.detail.value, (value) => {
                this.input.validation.rule = value;
                if (this.input.validation.rule !== 'type') {
                    const { type, ...rest } = this.input.validation;
                    this.input.validation = { ...rest };
                }
                if (this.input.validation.rule !== 'regex') {
                    const { regex, ...rest } = this.input.validation;
                    this.input.validation = { ...rest };
                }
                document.getElementById('validation-select').setAttribute('value', this.input.validation.rule);
                this.setDangerAttribute('validation-select', !this.input.validation.rule);
                this.inputTextPlaceholder = this.getTraslationInputRule();
                this.save();
            });
        };
        this.onRegexValidationInput = (event = undefined) => {
            if (!this.input.validation || this.shouldIgnoreEvent(event)) {
                return;
            }
            this.executeWithUndoRedo(this.input.validation?.regex, event?.target?.value, (value) => {
                this.input.validation.regex = value;
                this.save();
            }, 1000);
        };
        this.onValidationInput = (event = undefined) => {
            if (this.shouldIgnoreEvent(event)) {
                return;
            }
            this.executeWithUndoRedo(this.input.validation?.error, event?.target.value ?? this.input.validation?.error, (value) => {
                if (this.input.validation) {
                    this.input.validation.error = value;
                }
                this.save();
            }, 1000);
        };
        this.onTimeLimitInputBlur = (event = undefined) => {
            if (event) {
                const val = event.target.value;
                this.trackBuilderBlockContentInputInactivityChange('time-change', val, this.isValidInput);
                this.save();
            }
        };
        this.onTimeLimitInput = async (event = undefined) => {
            if (this.shouldIgnoreEvent(event)) {
                return;
            }
            this.executeWithUndoRedo(this.expirationTime, event?.target?.value ?? this.expirationTime, async (value) => {
                this.isValidInput = true;
                this.errorMessage = '';
                this.setDangerAttribute('time-limit-input', true);
                if (value) {
                    this.input.expiration = convertMinutesToHoursFormat(value);
                }
                if (this.expirationTime === '') {
                    this.errorMessage = await this.$translate('builder-tabs-content.InputIsEmpty');
                }
                else if (isNaN(Number(this.expirationTime))) {
                    this.errorMessage = await this.$translate('builder-tabs-content.inputIsNotANumber');
                }
                else if (!(isNaN(Number(this.expirationTime))) && (Number(this.expirationTime) % 1 != 0)) {
                    this.errorMessage = await this.$translate('builder-tabs-content.inputIsDecimal');
                }
                else if (Number(this.expirationTime) > 1380 || Number(this.expirationTime) < 1) {
                    this.errorMessage = await this.$translate('builder-tabs-content.timeLimitRange');
                }
                else {
                    this.setDangerAttribute('time-limit-input', false);
                }
                if (this.errorMessage !== '') {
                    this.isValidInput = false;
                    this.setErrorAtribute('time-limit-input', this.errorMessage);
                }
            }, 1000);
        };
        this.mimeTypeChanged = ({ detail: { value } }) => {
            this.input.validation.type = value;
            this.save();
        };
        this.save = async () => {
            this.action.input.$cardContent.document = {
                ...this.input.$cardContent.document,
                content: this.input.variable !== undefined && this.input.variable !== '' ?
                    this.input.variable :
                    await this.$translate('builder-tabs-content.media.userInput'),
            };
            await this.$onStateChanged(this.action);
        };
        this.toggleInputValidation = async (event) => {
            const value = event.detail.checked;
            this.trackBlockContentWaitInputChanged(this.inputToVariableEnabled, value);
            this.executeWithUndoRedo(this.input.validation, value ? new InputValidation() : undefined, (value) => {
                this.UndoRedoService.lock();
                try {
                    this.input.validation = angular.copy(value);
                    this.switchValidationEnabled();
                    document.getElementById('validation-select').setAttribute('value', this.input.validation?.rule);
                    this.setDangerAttribute('validation-select', !this.input.validation?.rule);
                    this.save();
                }
                finally {
                    this.UndoRedoService.unlock();
                }
            });
        };
        this.toggToVariable = async (event) => {
            const value = event.detail.checked;
            this.trackBlockContentWaitInputChanged(value, this.inputValidationEnabled);
            this.executeWithUndoRedo(this.input.variable, value ? '' : undefined, (value) => {
                this.input.variable = value;
                this.switchVariableEnabled();
                this.save();
            });
        };
        this.toggleInputToTimeLimit = async (event) => {
            const value = event.detail.checked;
            this.trackBlockContentWaitInputChanged(value, this.inputToTimeLimitEnabled);
            this.executeWithUndoRedo(this.input.expiration, value ? '' : undefined, (value) => {
                this.input.expiration = value;
                this.switchTimeLimitEnabled();
                this.save();
            });
        };
        this.input = this.action.input;
        this.inputValidationRules = [];
        this.loadInputValidationRules();
        this.init();
    }
    async init() {
        this.PipelineBuilderSegmentService.setApplication(this.application);
        this.types = CONTENT_TYPES.map((name) => ({
            value: name,
            label: name,
        }));
        if (this.input.validation &&
            !this.types.some((type) => type.value === this.input.validation.type)) {
            const type = this.input.validation.type;
            this.types = [...this.types, { value: type, label: type }];
        }
        this.addNewTypeData = {
            text: this.$translate.instant('builder-tabs-content.addType'),
        };
        await this.checkFeatures();
        this.$timeout(() => {
            this.switchTimeLimitEnabled();
            this.switchValidationEnabled();
            this.switchVariableEnabled();
            if (this.input.validation && this.input.validation.rule) {
                document.getElementById('validation-select').setAttribute('value', this.input.validation.rule);
            }
            this.checkInputVariable();
        });
        this.trackBuilderBlockContentUsersEntryOpened();
        this.inputTextPlaceholder = this.getTraslationInputRule();
    }
    async checkFeatures() {
        this.waitUserInputEnabled = await BuilderFeatures.builderWaitUserInputEnabled();
        this.undoRedoInputEnabled = await BuilderFeatures.builderUndoRedoInputEnabled();
    }
    getTraslationInputRule() {
        if (!this.input?.validation?.rule) {
            return;
        }
        switch (this.input.validation.rule.toString()) {
            case CONTENT_INPUT_VALUES.DATE:
                return 'builder-tabs-content.input.type.date';
            case CONTENT_INPUT_VALUES.NUMBER:
                return 'builder-tabs-content.input.type.number';
            case CONTENT_INPUT_VALUES.REGEX:
                return 'builder-tabs-content.input.type.regex';
            case CONTENT_INPUT_VALUES.TEXT:
                return 'builder-tabs-content.input.type.text';
            case CONTENT_INPUT_VALUES.TYPE:
                return 'builder-tabs-content.input.type.type';
        }
    }
    setDisabledAttribute(elementId, disabledValue) {
        const targetElement = document.getElementById(elementId);
        targetElement?.setAttribute('disabled', disabledValue);
    }
    setDangerAttribute(elementId, dangerValue) {
        const targetElement = document.getElementById(elementId);
        targetElement?.setAttribute('danger', dangerValue.toString());
    }
    setErrorAtribute(elementId, errorMessage) {
        const targetElement = document.getElementById(elementId);
        targetElement?.setAttribute('error-message', errorMessage);
    }
    executeWithUndoRedo(currentValue, newValue, evaluator, debounceMs = 0) {
        if (this.UndoRedoService.isLocked()) {
            return;
        }
        if (currentValue !== newValue && this.undoRedoInputEnabled) {
            debouncedCall(debounceMs, (oldValue) => {
                this.UndoRedoService.add({
                    data: {
                        state: this.state,
                    },
                    execute: () => {
                        evaluator(newValue);
                    },
                    undo: () => {
                        evaluator(oldValue);
                    },
                });
            }, currentValue);
        }
        evaluator(newValue);
    }
    checkInputVariable() {
        this.setDangerAttribute('variable-input', !this.input.variable ||
            this.input.variable.length > this.maxLength ||
            this.checkRegexVariable(this.input.variable));
    }
    async loadInputValidationRules() {
        this.inputValidationRules = [
            {
                label: await this.$translate('builder-tabs-content.type.text'),
                value: InputValidationRule.Text,
            },
            {
                label: await this.$translate('builder-tabs-content.type.number'),
                value: InputValidationRule.Number,
            },
            {
                label: await this.$translate('builder-tabs-content.type.date'),
                value: InputValidationRule.Date,
            },
            {
                label: await this.$translate('builder-tabs-content.type.regex'),
                value: InputValidationRule.Regex,
            },
            {
                label: await this.$translate('builder-tabs-content.type.type'),
                value: InputValidationRule.Type,
            },
        ];
    }
    //Getters, Setters and Switch functions
    get inputToVariableEnabled() {
        return this.input && this.input.variable !== undefined;
    }
    get expirationTime() {
        return this.input.expiration && String(convertHoursFormatToMinutes(this.input.expiration)) || '';
    }
    get typeValidation() {
        return this.input.validation.type;
    }
    set typeValidation(value) {
        this.executeWithUndoRedo(this.typeValidation, value, (value) => {
            this.input.validation.type = value;
        });
    }
    switchVariableEnabled() {
        this.setDisabledAttribute('variable-input', ((this.input.variable === undefined) ? 'true' : 'false'));
    }
    get inputValidationEnabled() {
        return this.input && this.input.validation !== undefined;
    }
    switchValidationEnabled() {
        const validationIsNotEnabled = ((this.input.validation === undefined) ? 'true' : 'false');
        this.setDisabledAttribute('validation-input', validationIsNotEnabled);
        this.setDangerAttribute('validation-select', true);
        this.setDisabledAttribute('validation-select', validationIsNotEnabled);
        if (validationIsNotEnabled === 'false') {
            this.onChangeRule();
            this.onValidationInput();
        }
        else {
            const validationSelect = document.getElementById('validation-select');
            if (!validationSelect) {
                return;
            }
            validationSelect.setAttribute('value', undefined);
        }
    }
    get inputToTimeLimitEnabled() {
        return this.input && this.input.expiration !== undefined;
    }
    switchTimeLimitEnabled() {
        const timeLimitIsNotEnabled = this.input.expiration === undefined;
        this.setDisabledAttribute('time-limit-input', String(timeLimitIsNotEnabled));
        this.trackBuilderBlockContentInputInactivityChange((timeLimitIsNotEnabled ? 'disabled' : 'enabled'));
        this.onTimeLimitInput();
        if (timeLimitIsNotEnabled) {
            this.setDangerAttribute('time-limit-input', false);
        }
    }
    // Miscellaneous functions
    checkRegexVariable(val) {
        return !(/^([a-zA-Z0-9]+)$/.test(val));
    }
    cancel() {
        this.close();
    }
    onToggleSaveReply(value) {
        this.hasSaveReply = value;
    }
    shouldIgnoreEvent(event) {
        // Should not handle native history actions if builder undo-redo is enabled
        return this.undoRedoInputEnabled && event?.detail?.inputType?.startsWith('history');
    }
    // Segment
    trackBuilderBlockContentInputInactivityInfoClicked() {
        this.PipelineBuilderSegmentService.trackBuilderBlockContentInputInactivityInfoClicked({
            BlockID: this.state.id,
        }, true);
    }
    trackBlockContentWaitInputChanged(setVariable, validInput) {
        this.PipelineBuilderSegmentService.trackBlockContentWaitInputChanged({
            SetVariable: setVariable,
            ValidInput: validInput,
            BlockID: this.state.id,
        }, true);
    }
    trackBuilderBlockContentInputInactivityChange(action, expiration = undefined, isSuccess = true) {
        this.PipelineBuilderSegmentService.trackBuilderBlockContentInputInactivityChange({
            BlockID: this.state.id,
            Action: action,
            Time: expiration,
        }, isSuccess);
    }
    trackBuilderBlockContentUsersEntryOpened() {
        this.PipelineBuilderSegmentService.trackBuilderBlockContentUsersEntryOpened({
            Action: 'ChangeContent',
            BlockID: this.state.id,
        }, true);
    }
    trackInputControllerUndoAction() {
        this.PipelineBuilderSegmentService.trackInputControllerUndoAction({
            Action: 'ChangeContent',
            BlockID: this.state.id,
        }, true);
    }
    trackInputControllerRedoAction() {
        this.PipelineBuilderSegmentService.trackInputControllerRedoAction({
            BlockID: this.state.id,
        }, true);
    }
}
InputController.$inject = ['action', 'state', '$timeout', 'close', '$translate', 'application', 'PipelineBuilderSegmentService', '$onStateChanged', 'UndoRedoService'];
